import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ variant = 'default' }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.substring(0, 2) || 'en';

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  if (variant === 'minimal') {
    return (
      <button
        onClick={toggleLanguage}
        data-testid="language-switcher"
        className="flex items-center gap-1.5 text-sm font-medium text-slate-500 dark:text-slate-400 hover:text-[#12355B] dark:hover:text-white transition-colors"
        aria-label="Change language"
      >
        <Globe className="w-4 h-4" />
        <span className="uppercase tracking-wide text-xs font-semibold">{currentLang === 'en' ? 'FR' : 'EN'}</span>
      </button>
    );
  }

  return (
    <button
      onClick={toggleLanguage}
      data-testid="language-switcher"
      className="flex items-center gap-2 px-3.5 py-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-sm font-medium text-slate-600 dark:text-slate-300 transition-colors"
      aria-label="Change language"
    >
      <Globe className="w-4 h-4 text-slate-400" />
      <span>{currentLang === 'en' ? 'Français' : 'English'}</span>
    </button>
  );
}
